export const clusterNameAnnotation = {
    text:
        'The cluster name is generated by Generative AI based on the labels of IPCs within the cluster, but it does not guarantee an accurate summary of the technical information of the cluster.'
}
